import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft} from "react-icons/fa6";
import "./SkillsMorePage.css";


export default function SkillsMorePage() {

  const navigate = useNavigate();

  const [skills, setSkills] = useState([]);

  useEffect(() => {

    const course_id = localStorage.getItem("course_id");
    if (!course_id) return;

    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/mind-mapping/startups/usecases-next/${course_id}`)
      .then(res => res.json())
      .then(data => {

  console.log("Skills API Response:", data);

  let fullList = [];

  // Case 1 → backend sends array directly
  if (Array.isArray(data)) {
    fullList = data;
  }

  // Case 2 → backend sends { usecases: [] }
  else if (Array.isArray(data.usecases)) {
    fullList = data.usecases;
  }

  // Case 3 → backend sends { data: [] }
  else if (Array.isArray(data.data)) {
    fullList = data.data;
  }

  // NOW remove first 5
if(fullList.length > 5){
   setSkills(data);
}else{
   setSkills([]);
}


})

      .catch(err => console.error(err));

  }, []);

 return (
  <div className="skills-page">

   <div className="skills-header">
    <button
        className="skills-back-btn"
        onClick={() => navigate(`/mind-mapping/sec-b`)}
    >
        <FaArrowLeft />
    </button>

    <h1 className="skills-title">
        Skill Based Opportunities
    </h1>
</div>


    {skills.length === 0 && (
      <p className="skills-empty">
        No additional skill opportunities available.
      </p>
    )}

   <ul className="skills-list">
  {skills.map((item,i)=>(
    <li key={i} className="skills-item">
      {item.usecase}
    </li>
  ))}
</ul>


  </div>
);

}
